import React, { useState, useEffect, useRef, useCallback } from "react";
import SavingsDataService from "./services/SavingsService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../components/TransactionTable";

const SavingsList = (props) => {
  const [savings, setSavings] = useState([]);
  const savingsRef = useRef();

  savingsRef.current = savings;

  let { owner } = useParams();

  const retrieveSavings = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    SavingsDataService.getAll(target)
      .then((response) => {
        setSavings(response.data || []);
      })
      .catch((e) => {
        console.error("SavingsList.retrieveSavings error:", e?.response?.status, e?.response?.data || e?.message || e);
        setSavings([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveSavings();
  }, [retrieveSavings]);

  const deleteSavings = useCallback((rowIndex) => {
    const id = savingsRef.current[rowIndex].id;
    SavingsDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/savings");
        const newSavings = [...savingsRef.current];
        newSavings.splice(rowIndex, 1);
        setSavings(newSavings);
      })
      .catch((e) => {
        console.error("deleteSavings error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  // wrappers for TransactionTable (accept row objects)
  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/savings/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/savings/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = savingsRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteSavings(idx);
  }, [deleteSavings]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={savings}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          /* omit `columns` so TransactionTable will use its default columns
             which include username, createdBy and updatedBy */
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/savings/add/${owner}`}>
           <button className="btn btn-sm btn-danger">Add Savings Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default SavingsList;
